import {ContractStatus, ContractVariant, TranslationKey} from '@enums'
import {CircularProgress, Stack, Typography} from '@mui/material'

import React from 'react'

import {ComposedComponents, UIKit} from '@components'

import {useContactFormModel} from './contract-form-model'
import {ContractProductForm, ContractPDFOverview, ContractSetupForm, CustomerForm} from './contract-form-steps'
import {BottomButtonsWrapper, pdfViewStyle} from './style'

/**
 * Contract Form page
 */
export function ContractFormPage() {
  const {
    steps,
    activeStep,
    formData,
    company,
    t,
    isSignatureOptionsModalVisible,
    isAgreementModalVisible,
    pdfUrl,
    creditCheckFailed,
    pdfTransferURl,
    loadingPdf,
    onAcceptTransferAgreement,
    setIsAgreementModalVisible,
    onSaveContract,
    isBackBtnVisible,
    onLeftBtnClick,
    onCenterBtnClick,
    onRightBtnClick,
    isLastStep,
    onSendForSigningBtnClick,
    setIsSignatureOptionsModalVisible,
    isFirstStep,
  } = useContactFormModel()

  const getCurrentForm = (activeStep: number) => {
    switch (activeStep) {
      case 0:
        return <ContractSetupForm onRightBtnClick={onRightBtnClick} />
      case 1:
        return <ContractProductForm />
      case 2:
        return <CustomerForm />
      case 3:
        return (
          <ContractPDFOverview
            isSignatureOptionsModalVisible={isSignatureOptionsModalVisible}
            setIsSignatureOptionsModalVisible={setIsSignatureOptionsModalVisible}
            pdfUrl={pdfUrl}
            creditCheckFailed={creditCheckFailed}
            onSendForSigningBtnClick={onSendForSigningBtnClick}
          />
        )
      default:
        return <></>
    }
  }
  return (
    <>
      <ComposedComponents.ContractHeader company={company} steps={steps} activeStep={activeStep} />
      {getCurrentForm(activeStep)}
      <UIKit.Modal
        open={isAgreementModalVisible}
        title={t(TranslationKey['Transfer Agreement'])}
        confirmButtonProps={{
          buttonText: t(TranslationKey.Continue),
          disabled: loadingPdf,
          onClick: () => onAcceptTransferAgreement(),
        }}
        cancelButtonProps={{buttonText: t(TranslationKey.Decline), onClick: () => setIsAgreementModalVisible(false)}}
        styles={{
          paper: {maxWidth: '100%'},
          content: {
            padding: 0,
            margin: 0,
            overflow: 'hidden',
          },
        }}
        fixed={
          <Typography>
            {t(TranslationKey['By continuing I confirm that I accept the transfer of the contract agreement'])}
          </Typography>
        }
        content={
          <Stack style={{width: '715px', height: '600px', padding: '15px'}}>
            {loadingPdf ? (
              <Stack style={{flex: 1, justifyContent: 'center', alignItems: 'center'}}>
                <CircularProgress />
              </Stack>
            ) : (
              <iframe
                src={`${pdfTransferURl}#toolbar=0&navpanes=0&view=FitW`}
                title="PDF Viewer"
                width="100%"
                height="100%"
                style={pdfViewStyle}
              />
            )}
          </Stack>
        }
      />

      <BottomButtonsWrapper>
        <ComposedComponents.FormButtons
          leftButton={{label: t(TranslationKey.Discard), onClick: onLeftBtnClick}}
          {...(isBackBtnVisible() && {centerButton: {label: t(TranslationKey.Back), onClick: onCenterBtnClick}})}
          {...(isLastStep() && {
            auxiliaryButton: {
              label: t(TranslationKey['Save as draft']),
              onClick: () => onSaveContract(ContractStatus.DRAFT),
            },
          })}
          {...(!isFirstStep() && {
            rightButton: {
              label: t(
                TranslationKey[
                  isLastStep()
                    ? formData.contractSetupData.type === ContractVariant.QUOTE
                      ? 'Save as quote'
                      : 'Save and send for signing'
                    : 'Next'
                ],
              ),
              onClick: onRightBtnClick,
            },
          })}
        />
      </BottomButtonsWrapper>
    </>
  )
}
